/* Flavour in Motion. Native scrolling, no animation dependency or paid runtime. */
(() => {
  const clamp = (n, min = 0, max = 1) => Math.max(min, Math.min(max, n));
  const ramp = (p, from, to) => {
    const t = clamp((p - from) / (to - from));
    return t * t * (3 - 2 * t);
  };
  const lerp = (a, b, t) => a + (b - a) * t;
  const pose = (frames, p) => {
    for (let i = 1; i < frames.length; i++) {
      if (p <= frames[i][0]) {
        const a = frames[i - 1],
          b = frames[i],
          t = ramp(p, a[0], b[0]);
        return a.slice(1).map((v, j) => lerp(v, b[j + 1], t));
      }
    }
    return frames[frames.length - 1].slice(1);
  };

  function setup(root) {
    if (root.motionCleanup) root.motionCleanup();
    const aborter = new AbortController();
    const signal = aborter.signal;
    const story = root.querySelector("[data-motion-story]");
    const stage = root.querySelector(".motion-stage");
    const main = root.querySelector(".motion-carton-main");
    const left = root.querySelector(".motion-carton-left");
    const right = root.querySelector(".motion-carton-right");
    const dark = root.querySelector(".motion-stage-dark");
    const blue = root.querySelector(".motion-stage-blue");
    const orbit = root.querySelector(".motion-orbit");
    const chocolate = root.querySelector(".motion-chocolate");
    const opening = root.querySelector('[data-motion-copy="opening"]');
    const taste = root.querySelector('[data-motion-copy="taste"]');
    const finale = root.querySelector('[data-motion-copy="finale"]');
    const toggle = document.querySelector("[data-motion-toggle]");
    const reduced = matchMedia("(prefers-reduced-motion: reduce)");
    const phone = matchMedia("(max-width: 700px)");
    let optedOut = false,
      pending = 0,
      active = true,
      progress = 0;

    function visible(el, opacity, offset = 0) {
      el.style.opacity = opacity;
      el.style.transform = `translateY(${offset}px)`;
      const hidden = opacity < 0.08;
      el.inert = hidden;
      el.setAttribute("aria-hidden", String(hidden));
      el.style.visibility = hidden ? "hidden" : "visible";
      el.style.pointerEvents = hidden ? "none" : "auto";
    }
    function render() {
      pending = 0;
      const enabled = !reduced.matches && !optedOut;
      root.classList.toggle("is-motion", enabled);
      if (toggle) {
        toggle.hidden = false;
        toggle.disabled = reduced.matches;
        toggle.setAttribute("aria-pressed", String(!enabled));
        toggle.setAttribute(
          "aria-label",
          reduced.matches
            ? "Motion disabled by your system preference"
            : enabled
              ? "Turn motion off"
              : "Turn motion on",
        );
        toggle.querySelector("span").textContent = enabled ? "on" : "off";
      }
      const bounds = story.getBoundingClientRect();
      const top =
        parseFloat(
          getComputedStyle(document.body).getPropertyValue("--motion-header"),
        ) || 88;
      progress = enabled
        ? clamp(
            (top - bounds.top) /
              Math.max(1, story.offsetHeight - stage.offsetHeight),
          )
        : 0;
      const p = progress,
        mobile = phone.matches;
      const frames = mobile
        ? [
            [0, 1, 1, -18, 1],
            [0.38, -13, 17, 11, 0.72],
            [0.6, -13, 17, 11, 0.72],
            [0.94, 0, 4, -11, 0.77],
            [1, 0, 4, -11, 0.77],
          ]
        : [
            [0, 17, 7, -14, 1],
            [0.38, -25, 19, 9, 0.65],
            [0.6, -25, 19, 9, 0.65],
            [0.94, 0, 15, -9, 0.73],
            [1, 0, 15, -9, 0.73],
          ];
      const [x, y, angle, scale] = pose(frames, p);
      main.style.transform = `translate(-50%,-50%) translate(${x}vw,${y}vh) rotate(${angle}deg) scale(${scale})`;
      const fan = ramp(p, 0.66, 0.94);
      left.style.opacity = fan;
      right.style.opacity = fan;
      left.style.transform = `translate(-50%,-50%) translate(${lerp(0, mobile ? -14 : -25, fan)}vw,${lerp(15, mobile ? -7 : 1, fan)}vh) rotate(${lerp(-9, -24, fan)}deg) scale(${mobile ? 0.67 : 0.63})`;
      right.style.transform = `translate(-50%,-50%) translate(${lerp(0, mobile ? 13 : 25, fan)}vw,${lerp(15, mobile ? 16 : 24, fan)}vh) rotate(${lerp(-9, 12, fan)}deg) scale(${mobile ? 0.67 : 0.63})`;
      dark.style.opacity = ramp(p, 0.12, 0.3);
      blue.style.opacity = ramp(p, 0.64, 0.84);
      orbit.style.opacity = 1 - ramp(p, 0.08, 0.25);
      orbit.style.transform = `translate(${8 - p * 15}%,${-p * 70}px) scale(${1 + p * 0.3})`;
      visible(opening, 1 - ramp(p, 0.09, 0.24), -p * 80);
      const tasteOpacity = ramp(p, 0.17, 0.29) * (1 - ramp(p, 0.59, 0.69));
      visible(taste, tasteOpacity, (1 - ramp(p, 0.17, 0.29)) * 25);
      chocolate.style.transform = `translateY(${lerp(55, -10, ramp(p, 0.23, 0.6))}px) rotate(${lerp(-10, 4, ramp(p, 0.25, 0.6))}deg) scale(${lerp(0.85, 1.08, ramp(p, 0.25, 0.6))})`;
      visible(finale, ramp(p, 0.62, 0.75), (1 - ramp(p, 0.62, 0.75)) * 25);
      stage.dataset.scene =
        p < 0.23 ? "opening" : p < 0.69 ? "taste" : "finale";
      stage.dataset.progress = p.toFixed(3);
    }
    function schedule() {
      if (!pending && active) pending = requestAnimationFrame(render);
    }
    addEventListener("scroll", schedule, { passive: true, signal });
    addEventListener("resize", schedule, { passive: true, signal });
    reduced.addEventListener("change", schedule, { signal });
    phone.addEventListener("change", schedule, { signal });
    if (toggle)
      toggle.addEventListener(
        "click",
        () => {
          if (reduced.matches) {
            toggle.setAttribute(
              "aria-label",
              "Motion follows your system reduced-motion preference",
            );
            return;
          }
          optedOut = !optedOut;
          render();
        },
        { signal },
      );
    root.querySelectorAll("[data-flavour]").forEach((button) => {
      button.addEventListener(
        "click",
        () => {
          root
            .querySelectorAll("[data-flavour]")
            .forEach((other) =>
              other.setAttribute("aria-pressed", String(other === button)),
            );
          root.querySelectorAll("[data-flavour-image]").forEach((img) => {
            img.hidden = img.dataset.flavourImage !== button.dataset.flavour;
          });
          const otherFlavour =
            button.dataset.flavour === "brownie" ? "hazelnut" : "brownie";
          left.src = root.querySelector(
            `[data-flavour-image="${otherFlavour}"]`,
          ).src;
          root.querySelectorAll("[data-flavour-name]").forEach((el) => {
            el.textContent = button.dataset.flavourTitle;
          });
          root.querySelectorAll("[data-flavour-link]").forEach((el) => {
            el.href = button.dataset.flavourUrl;
          });
        },
        { signal },
      );
    });
    // Close the native details menu with Escape or after selecting an anchor.
    const menu = document.querySelector(".motion-menu");
    if (menu) {
      document.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Escape" && menu.open) {
            menu.open = false;
            menu.querySelector("summary").focus();
          }
        },
        { signal },
      );
      menu.querySelectorAll("a").forEach((link) =>
        link.addEventListener(
          "click",
          () => {
            menu.open = false;
          },
          { signal },
        ),
      );
    }
    const observer = new IntersectionObserver(
      (entries) => {
        active = entries[0].isIntersecting;
        if (active) schedule();
      },
      { rootMargin: "100px" },
    );
    observer.observe(story);
    const resize = new ResizeObserver(schedule);
    resize.observe(story);
    document.addEventListener(
      "visibilitychange",
      () => {
        if (!document.hidden) schedule();
      },
      { signal },
    );
    root.motionCleanup = () => {
      aborter.abort();
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(pending);
    };
    render();
  }
  document.querySelectorAll("[data-motion-home]").forEach(setup);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-motion-home]").forEach(setup);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    event.target
      .querySelectorAll("[data-motion-home]")
      .forEach((root) => root.motionCleanup?.());
  });
})();
